/* RECEPTION FEATURES */

export type ReceptionFeaturesAliases =
  | typeof RECEPTION_FEATURES_ALIAS_ADULTS
  | typeof RECEPTION_FEATURES_ALIAS_CHILDREN
  | typeof RECEPTION_FEATURES_ALIAS_PREGNANTS
  | typeof RECEPTION_FEATURES_ALIAS_BREAST_FEEDING
  | typeof RECEPTION_FEATURES_ALIAS_ALLERGICS
  | typeof RECEPTION_FEATURES_ALIAS_DIABETICS
  | typeof RECEPTION_FEATURES_ALIAS_DRIVERS
  | typeof RECEPTION_FEATURES_INTERACTION_WITH_ALCOHOL;

export const RECEPTION_FEATURES_ALIAS_ADULTS = 'adults';
export const RECEPTION_FEATURES_ALIAS_CHILDREN = 'children';
export const RECEPTION_FEATURES_ALIAS_PREGNANTS = 'pregnants';
export const RECEPTION_FEATURES_ALIAS_BREAST_FEEDING = 'breastfeeding';
export const RECEPTION_FEATURES_ALIAS_ALLERGICS = 'allergics';
export const RECEPTION_FEATURES_ALIAS_DIABETICS = 'diabetics';
export const RECEPTION_FEATURES_ALIAS_DRIVERS = 'drivers';
export const RECEPTION_FEATURES_INTERACTION_WITH_ALCOHOL = 'interaction_with_alcohol';

export const NamesByReceptionFeaturesAliases = {
  [RECEPTION_FEATURES_ALIAS_ADULTS]: 'Взрослым',
  [RECEPTION_FEATURES_ALIAS_CHILDREN]: 'Детям',
  [RECEPTION_FEATURES_ALIAS_PREGNANTS]: 'Беременным',
  [RECEPTION_FEATURES_ALIAS_BREAST_FEEDING]: 'Кормящим мамам',
  [RECEPTION_FEATURES_ALIAS_ALLERGICS]: 'Аллергикам',
  [RECEPTION_FEATURES_ALIAS_DIABETICS]: 'Диабетикам',
  [RECEPTION_FEATURES_ALIAS_DRIVERS]: 'Водителям',
  [RECEPTION_FEATURES_INTERACTION_WITH_ALCOHOL]: 'Взаимодействие с алкоголем',
} as const;

export const RECEPTION_FEATURES_LEVEL_ALLOWED = 'allowed';
export const RECEPTION_FEATURES_LEVEL_FORBIDDEN = 'forbidden';
export const RECEPTION_FEATURES_LEVEL_WITH_CAUTION = 'with_caution';
